import React, {useState, memo, useRef, useEffect} from "react";
import {useTranslation} from "react-i18next";
import classNames from "classnames";

import {formatNumberToEuropeanStyle, INTERACTION} from "utils";

import CountDownBlock from "./CountDownBlock";
import {Icon} from "components/atoms";

import {DeleteIcon, EditIcon} from "assets/svg";

const BazaarCurrentItemAccordion = (
    {
        type,
        items,
        hasMore,
        isLoading,
        totalItems,
        currencyRange,
        onScrollBottom,
        actionCallBack,
        totalInteracted,
    }
) => {
    const contentRef = useRef(null);
    const {t} = useTranslation()

    const [isOpenAccordion, setIsOpenAccordion] = useState(false)

    const iconStyle = classNames("accordion-icon", {"rotate": isOpenAccordion})
    const typeText = type === INTERACTION.BUY ? t("offered") :  t("listed")

    useEffect(() => {
        const contentElement = contentRef.current;
        if (contentElement) {
            contentElement.addEventListener("scroll", handleScroll);
        }
        return () => {
            if (contentElement) {
                contentElement.removeEventListener("scroll", handleScroll);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpenAccordion, hasMore]);

    const handleScroll = () => {
        if (contentRef.current) {
            const {scrollTop, scrollHeight, clientHeight} = contentRef.current;

            if (scrollTop + clientHeight >= scrollHeight - 1) {
                onScrollBottom();
            }
        }
    }

    return (
        <div className="bazaar_current-item_accordion">
            <button onClick={() => setIsOpenAccordion(!isOpenAccordion)} className="bazaar_current-item_accordion_head">
                {type === INTERACTION.BUY
                    ? <div>{totalInteracted} {typeText}</div>
                    : <div>{totalInteracted} {t("outOf")} {totalItems} {typeText}</div>}
                <div className={iconStyle}>
                    <span>{currencyRange} KMT</span>
                    <span><Icon name="selectArrow"/></span>
                </div>
            </button>
            {isOpenAccordion &&
                <div className="bazaar_current-item_accordion_content" ref={contentRef}>
                    {items.map((item) =>
                        <div key={item.id} className="bazaar_current-item_accordion_content_item">
                            <div>
                                <span>1 {typeText} {t("for")}</span>
                                <span>{formatNumberToEuropeanStyle(item.price, true)} KMT</span>
                                <span>({item.usd_price})</span>
                                <div><EndingTime expiration={item.expiration_date}/></div>
                            </div>
                            <div>
                                <EndingTime expiration={item.expiration_date}/>
                                <button onClick={() => actionCallBack(INTERACTION.EDIT, item)}><EditIcon/></button>
                                <button onClick={() => actionCallBack(INTERACTION.CANCEL, item)}><DeleteIcon/></button>
                            </div>
                        </div>
                    )}
                    {isLoading && Array(5).fill("").map((_, index) =>
                        <div key={index} className="bazaar_current-item_accordion_content_item_skeleton skeleton"/>)}
                </div>
            }
        </div>
    )
}

export default memo(BazaarCurrentItemAccordion)

const EndingTime = ({expiration}) => {
    const {t} = useTranslation()
   return <span className="ending-time">{t("endingIn")} <CountDownBlock expirationDate={expiration}/></span>
}